// A tiny shared note: "where is the TV screen on the About page, and where should the player's picture go when the song is not on it?"
// The TV (components/AboutTv.js) says which element is its screen; the player (components/MiniPlayer.js) moves its one <video> into it
// while a song plays there, and hands it back to its own hidden place when the screen goes away. Nothing here touches the server.
let host = null;        // the element inside the TV screen (or null when the TV is not on the page)
let home = null;        // the player's own hidden place for its <video>
const listeners = new Set();

export function setTvScreenHost(el) {
  const next = el || null;
  if (host && host !== next && home) {
    // The screen is leaving the page. A video that is taken out of the page stops, so give it back to the player right now.
    const v = host.querySelector("video");
    if (v) home.appendChild(v);
  }
  host = next;
  listeners.forEach((fn) => {
    try { fn(host); } catch { /* a listener must never break the page */ }
  });
}

export function getTvScreenHost() {
  return host;
}

export function setVideoHome(el) {
  home = el || null;
}

export function subscribeTvScreen(fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}
